import React from 'react';
import {SortContainer} from './style';

export const Sortable = ({sort, currency, label, ascendingSort, descendingSort, sortHandleClick}) => {
	return (
		<SortContainer onClick={ () => {sortHandleClick(sort.value) }}>
			<div className="sort-icon-container">
				<i className={`ascending-descending ${(sort.sort_field === sort.value && sort.sort_type === 'asc') && 'sort-active'} icon mapsa-arrow`} > </i>
				<i className={`ascending-descending ${(sort.sort_field === sort.value && sort.sort_type === 'desc') && 'sort-active'} icon mapsa-down-arrow`} > </i>
			</div>
			<div className="text-container">
				{ label }
				{ currency && <span className="rials">{`(${localStorage.getItem('currency')})`}</span> }
			</div>
		</SortContainer>
	);
};
